import PropTypes from 'prop-types'

import { TpmsSensorTypes } from '../../models/tpms/tpms-sensor-types-enum'
import { tpmsSensorStatePropType } from './tpms-sensor-state-prop-type'

/**
 * @typedef {Object} TpmsSensor
 * @property {boolean} activated
 * @property {string} sensorId
 * @property {string} serialNo
 * @property {TpmsSensorState} state
 * @property {string} type
 */
export const tpmsSensorPropType = PropTypes.shape({
    activated: PropTypes.bool,
    sensorId: PropTypes.string,
    serialNo: PropTypes.string,
    state: tpmsSensorStatePropType,
    type: PropTypes.oneOf(Object.values(TpmsSensorTypes))
})
